import './App.css';
import Header from './Header';
import Home from './Home';
import Footer from './Footer';
import Login from './Login';
import Dashboard from './Dashboard';
import React, { useState } from 'react';

function App() {
  const [currentPage, setCurrentPage] = useState('home'); // 'home', 'login', 'dashboard'
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);

  const handleLoginSuccess = (user) => {
    setIsLoggedIn(true);
    setCurrentUser(user || null);
    setCurrentPage('dashboard');
  };

  const handleLogout = () => {
    try { localStorage.removeItem('lbUser'); } catch {}
    setCurrentUser(null);
    setIsLoggedIn(false);
    setCurrentPage('home');
  };

  return (
    <div className="App">
      <Header currentUser={currentUser} />
      {currentPage === 'home' && <Home onLoginClick={() => setCurrentPage('login')} />}
      {currentPage === 'login' && <Login onLoginSuccess={handleLoginSuccess} />}
      {currentPage === 'dashboard' && <Dashboard />}
      <Footer />
      {/* Navigation buttons (top-right) */}
      <div style={{ position: 'fixed', top: 20, right: 20, display: 'flex', gap: '10px', zIndex: 2000 }}>
        {!isLoggedIn ? (
          <>
            <button onClick={() => setCurrentPage('home')} style={{ padding: '8px 18px', fontSize: '1rem' }}>
              Home
            </button>
            <button onClick={() => setCurrentPage('login')} style={{ padding: '8px 18px', fontSize: '1rem' }}>
              Login
            </button>
          </>
        ) : (
          <>
            <button onClick={() => setCurrentPage('dashboard')} style={{ padding: '8px 18px', fontSize: '1rem' }}>
              Dashboard
            </button>
            <button onClick={handleLogout} style={{ padding: '8px 18px', fontSize: '1rem', background: '#d32f2f', color: '#fff' }}>
              Logout
            </button>
          </>
        )}
      </div>
    </div>
  );
}

export default App;
